import { create } from "zustand";
import { toast } from "react-toastify";
import axiosInstance from "../../../../Hooks/axoisInstance";
import { API_BASE_URL1 } from "../../../Services/baseApiUrl";

export const useContainerBulkUploadStore = create((set) => ({
  isBulkUploadLoading: false,
  bulkUploadData: null,
  showBulkUploadModal: false,

  bulkUploadContainer: async (file) => {
    set({ isBulkUploadLoading: true });
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post(
        `${API_BASE_URL1}MasterCreate/BulkUploadContainer`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      set({
        bulkUploadData: response.data,
        showBulkUploadModal: true,
        isBulkUploadLoading: false,
      });

      toast.success(
        response?.data?.message || "Containers uploaded successfully"
      );
      return { success: true };
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Upload failed";
      toast.error(typeof msg === "string" ? msg : "Upload failed");
      set({ isBulkUploadLoading: false });
      return { success: false };
    }
  },

  closeBulkUploadModal: () => {
    set({ showBulkUploadModal: false, bulkUploadData: null });
  },
}));
